import React from "react";
import { Modal, Text, Button, Group, TextInput } from "@mantine/core";
import classes from "./view.module.css";
import { RowDataNotification } from "./types";

interface ViewNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  notificationData: RowDataNotification;
}

const ViewNotificationModal: React.FC<ViewNotificationModalProps> = ({
  isOpen,
  onClose,
  notificationData,
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          View Notification
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <div className={classes.spacing}>
        <TextInput label="Title:" value={notificationData.title} readOnly />

        <TextInput label="Body:" value={notificationData.body} readOnly />

        <TextInput label="Route:" value={notificationData.route ? notificationData.route : ''} readOnly />

        {/* <Group className={classes.buttonBottom}>
          <Button onClick={onClose} className={classes.buttonClose}>
            Close
          </Button>
        </Group> */}
      </div>
    </Modal>
  );
};

export default ViewNotificationModal;
